module.exports = __webpack_public_path__ + "static/media/Micronesia.fd4b2275.png";